export default __webpack_public_path__ + "static/media/floating.f222a3e3.png";